export default "__VITE_ASSET__DJm$T56j__"